import React, { useState, useEffect } from "react";
import FeatureList from "../../Components/FeatureList";

import "./index.scss";

export default function Features() {
  return (
    <div className="product-list-page">
      <section className="product-list-page-header js-section_nav-dark">
        <div className="container mx-auto">
          <div className="parent">
            <div className="div1">
              <div className="product-list-page-header__title">
                lugath<br/> <span className="shine">features</span>
              </div>
            </div>
            <div className="div2">
              <div className="product-list-page-header__content">
                <div className="product-list-page-header__content-desc">
                  Lugath offers a comprehensive suite of features to help you
                  manage localization from end-to-end.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FeatureList
        options={{
          shape: "image",
          imageMinWidth: "64px",
        }}
        data={{
          title: (
            <>
              <b>All the features you need,</b> <br />
              All in one place
            </>
          ),
          description: (
            <>
              Discover the latest technologies powered by AI to maximize
              efficiency in your translation and localization workflow.
            </>
          ),
        }}
      />
    </div>
  );
}
